/** مسیر سند با حفظ زمینهٔ پروژه برای فیلتر نمایش */
export function accountingDocumentHref(
  documentId: string,
  opts?: { projectId?: number; edit?: boolean; print?: boolean },
): string {
  const suffix = opts?.edit ? '/edit' : opts?.print ? '/print' : '';
  const base = `/accounting-documents/${documentId}${suffix}`;
  if (opts?.projectId && opts.projectId > 0) {
    return `${base}?projectId=${opts.projectId}`;
  }
  return base;
}

export function parseProjectScopeId(raw: string | null | undefined): number | null {
  if (!raw?.trim()) return null;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}

type DocumentRowWithProject = {
  projectId?: number | null;
  debit?: number;
  credit?: number;
};

export function filterDocumentRowsForProject<T extends DocumentRowWithProject>(
  rows: T[],
  projectId: number | null,
): T[] {
  if (!projectId) return rows;
  return rows.filter((r) => r.projectId != null && Number(r.projectId) === projectId);
}

export function sumDocumentRowTotals(rows: Array<{ debit?: number; credit?: number }>): {
  totalDebit: number;
  totalCredit: number;
  difference: number;
} {
  const totalDebit = rows.reduce((s, r) => s + Number(r.debit ?? 0), 0);
  const totalCredit = rows.reduce((s, r) => s + Number(r.credit ?? 0), 0);
  return { totalDebit, totalCredit, difference: totalDebit - totalCredit };
}
